<template lang="pug">
  div.geo.map-treads
    router-view
    div.toolbar
      .mobile-title
        span.mobile-title__number.semibold 01
        span Территориальная схема
      div.toolbar__line
        h1.title.toolbar__title
          span.desktop {{$translate('Схема потоков отходов')}}
          span.mobile {{$translate('Схема потоков')}}
        e-button-add(
          v-if="hasDownloadFileButton && getFileNameDownload($route.name)"
          @click="handleDownload($route.name)"
          label="Скачать приложения к ТС"
          btnDefaultClass=" "
        ).actions-panel__button.btn-text.button.button_usual
        div.actions-panel
          downloadFile(
            text="KML"
            className="download-kml"
            visible=false
            :url="downloadKMLEndpoint"
            v-if="hasThreadsKmlExport"
          )
          downloadFile(
            text="Shapefile"
            className="download-shape"
            visible =false
            :url="downloadShapefileEndpoint"
            v-if="hasShapefileExport"
          )
          button.reset-btn.button.button_usual(
            @click="handleReoThreads"
            v-if="hasReoThreads && !isGuest"
          ) Экспорт в ФГИС УТКО
    div(v-if="yearList && yearList.length").year-track
      span.year-track__title Дата: {{year}}
      div.year-track__wrapper
        span.year-track__start {{min}}
        div.year-track__path
          el-slider(
            style="width:100%;"
            :min="min"
            :max="max"
            v-model="year"
            @change="handleYear"
            :step="1"
            show-stops
          )
        span.year-track__end {{max}}
    map-mapping-legend(
      :mappingCurrentLegend="mappingCurrentLegend"
      :legendItems="legendItems"
    )
    div.new-map
      div(ref="map" v-once).map.map_threads.absolute
      map-legend(
        :showRemoved="true"
        :dateTkoStarts="dateTkoStarts"
        :dateTkoEnds="dateTkoEnds"
        :map="map"
        @showAll="showAll"
        @showAllThreads="showAllThreads"
        @showModelTariffs="showModelTariffsHandle"
        @showHideLine='showHideLine'
        @initThreadTypes='initThreadTypesKeys'
        @updateFkko="updateFkko"
        @updateDangerClass="updateDangerClass"
        @updateRegop="updateRegop"
        @changeDateTko="changeDateTko"
        @updateStatus="updateStatus"
        @setOperators="setOperators"
        @change="setSelectedMappingObject"
        @rosreestrChangeView="onRosreestrChangeView"
        @refreshMap="refreshMap"
      )
</template>

<script>
import L from 'leaflet'

import {
  atu,
  map as mapEndpoints,
  threads as threadsEndpoints,
} from '@/api/api-endpoints'
import year from '@/utils/year'
import url from '@/utils/url'
import { MARKER_ICON } from '@/config/map'
import DownloadFile from '@/app/geo/components/download-file'
import { REGION_CONFIG } from '@/config/regions'
import MapPopup from '@/utils/map/popup/MapPopup'
import hasMixin from '@/mixins/has-mixin'
import mapLegend from './components/map-legend'
import MapMappingLegend from './components/map-mapping-legend'
import baseMap from './mixins/base-map'
import mappingMixin from './mixins/mapping-mixin'
import { threadsDateSliderMixin } from './mixins/threads/date-slider'
import ThreadsDrawer from './utils/ThreadsDrawer'
import measureMixin from './mixins/measure-mixin'
import downloadFileMixin from '@/mixins/download-file-mixin'

const mapConfig = REGION_CONFIG.map

export default {
  name: 'threads',
  components: {
    mapLegend,
    DownloadFile,
    MapMappingLegend,
  },
  mixins: [
    baseMap,
    mappingMixin,
    measureMixin,
    threadsDateSliderMixin,
    hasMixin,
    downloadFileMixin,
  ],
  data() {
    this.map = null
    return {
      q: '',
      showRight: true,
      showMapCard: false,
      selectedMappingObject: ' ',
      selectedMappingObjectZoom: null,
      openedOperator: null,
      operatorLayer: null,
    }
  },
  computed: {
    contextmenu() {
      return false
    },
    contextmenuOpened() {
      return true
    },
    mappingCurrentLegend() {
      let currentOnZoom = null
      if (this.selectedMappingObject && this.selectedMappingObjectZoom) {
        let zoom = this.selectedMappingObjectZoom
        let current = this.mappingConfObject[this.selectedMappingObject]
        if (!current) {
          return {}
        }
        current.legends.forEach((v) => {
          if (
            v.hasOwnProperty('showOnZoom') &&
            v.showOnZoom.indexOf(zoom) > -1
          ) {
            currentOnZoom = v
          } else if (!currentOnZoom) {
            currentOnZoom = v
          }
          if (currentOnZoom) {
            if (!v.title) {
              currentOnZoom.title = current.title
            }
            currentOnZoom.items.forEach((item, i) => {
              currentOnZoom.items[i].style = Object.assign(
                currentOnZoom.items[i].style || {},
                v.style || {}
              )
            })
          }
        })
      }
      return currentOnZoom
    },
    downloadKMLEndpoint() {
      return mapEndpoints.downloadKML(this.year)
    },
    downloadShapefileEndpoint() {
      return threadsEndpoints.downloadShapefile(this.year)
    },
    downloadReoThreadsEndpoint() {
      return threadsEndpoints.downloadReoThreads()
    },
  },
  methods: {
    initThreadTypesKeys(typeKeys) {
      this.allowThreadTypes = typeKeys
      this.refreshMap()
    },
    afterMapInit() {
      this.threadsDrawer = new ThreadsDrawer(this.map, this)
      this.subsSetView = this.$emitter.listen('geo.mapSetView', this.setView)
      this.subsUpdateMap = this.$emitter.listen('geo.mapUpdate', this.updateMap)
      this.subsRefreshMap = this.$emitter.listen(
        'geo.mapRefresh',
        this.refreshMap
      )
    },
    letSearch() {
      this.replaceRoute({ q: this.q }, false)
    },
    getThreadEndpoint(route) {
      if (!route.query.year) {
        route.query.year = year.getCurrentYear()
      }
      if (!route.query?.flows) {
        route.query.flows = true
      }
      return mapEndpoints.threads(route)
    },
    handleYear(year) {
      this.yearHandler(year)
      const apoIds = url.getHashParam('apo_ids')
      if (apoIds) this.geoObjectsById({ apoIds, currentYear: year })
    },

    setOperators(data) {
      if (this.operatorLayer) {
        this.map.removeLayer(this.operatorLayer)
      }
      this.operatorLayer = L.layerGroup()
      data.forEach((operator) => {
        const latLng = L.latLng(operator.lat, operator.lng)

        const marker = L.marker(latLng, {
          icon: MARKER_ICON,
        })
        const popup = new MapPopup({
          autoPan: true,
          layerConfig: {
            menuClass: 'transp',
            label: 'Операторы',
            className: 'cluster-marker transport',
            iconType: 'transp',
            endpoint: mapEndpoints.transportById(operator.id),
            groups: {
              transport: {
                hideFromMenu: true,
                iconType: 'transport',
                label: 'Операторы',
                color: 'transp',
                restApiOrder: 1,
              },
            },
          },
          subLayerConfig: {
            hideFromMenu: true,
            iconType: 'transport',
            label: 'Операторы',
            color: 'transp',
            restApiOrder: 1,
          },
          id: operator.id,
        })

        marker.bindPopup(popup)
        this.operatorLayer.addLayer(marker)
        this.map.addLayer(this.operatorLayer)
      })
      this.refreshMap()
    },
    async handleReoThreads() {
      try {
        await this.$store.dispatch('updateUrlEndpoint', {
          url: threadsEndpoints.downloadReoThreads(),
        })
        this.$notify.success({
          title: `данные отправлены`,
        })
      } catch (e) {
        this.$notify.error({
          title: `экспорт не удался`,
        })
      }
    },
    async getObjects() {
      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjectUpdateOrCreate(),
          fromCache: false,
          notReactive: false,
        })
      ).data.data
    },
  },
  mounted() {
    if (REGION_CONFIG.rosreestr_view === 'yandex') {
      this.addYandexTile()
    }
    this.onMappingCurrentLegend()
    this.refreshMap()
    this.getObjects()
    this.map.on('zoomend', () => {
      this.threadsDrawer && this.threadsDrawer.drawGeoJson()
    })
  },
  asyncData({ store, route, methods }) {
    let promises = []
    if (methods.getThreadEndpoint) {
      promises.push(
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getThreadEndpoint(route),
          fromCache: false,
          notReactive: false,
        })
      )
    }

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.heatMapRegOperators(
          route.query.zoom || mapConfig.zoom
        ),
        fromCache: false,
        notReactive: false,
      })
    )

    if (methods.getYearListEndpoint) {
      promises.push(
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getYearListEndpoint(),
          fromCache: true,
          cache: true,
          notReactive: false,
        })
      )
    }

    return Promise.all(promises)
  },
  destroyed() {
    this.destroyMap()
  },
  destroyAsync() {
    this.$store.commit('skipAsyncData', {
      name: 'geo.*',
      depth: 1,
      value: false,
    })
    if (this.subsSetView) {
      this.subsSetView.unsubscribe()
    }
    if (this.subsUpdateMap) {
      this.subsUpdateMap.unsubscribe()
    }
    if (this.subsRefreshMap) {
      this.subsRefreshMap.unsubscribe()
    }
    if (this.threadsDrawer) {
      this.threadsDrawer.destroy()
    }
  },
}
</script>
<style lang="scss">
.main-layout {
  .tooltip__head.tooltip__head_operator {
    padding: 0;
    padding-bottom: 20px;
  }

  .tooltip__body.tooltip__body_operator {
    padding: 0;
  }
}
</style>
